import { HttpClient } from '../HttpClient';
import { WebSettings } from '../../types/webSettingsInterface';
/**
 * * Get Web Settings
 */
export const GetWebSettings = async (): Promise<WebSettings[]> => {
  try {
    const { data } = await HttpClient.get('api/web/settings');
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
